import React, {Component} from 'react';
import Statistic from '../templates/statistic';

class statisticPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:    [],
            message: {},
        };
        this.changeState = this.changeState.bind(this);
        this.getData = props.tools.getData.bind(this);
        this.setData = props.tools.setData.bind(this);
    }

    changeState(data) {
        this.setState(data)
    }

    render() {
        return (
            <div className="pageBlock">
                <Statistic {...this}/>
            </div>
        );
    }
}

export default statisticPage;